var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 13.3334C10.2215 13.3334 12.8332 10.7217 12.8332 7.50002C12.8332 4.27836 10.2215 1.66669 6.99984 1.66669C3.77818 1.66669 1.1665 4.27836 1.1665 7.50002C1.1665 10.7217 3.77818 13.3334 6.99984 13.3334Z",
    stroke: "#626262",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66676 2.25H5.2501C4.1126 5.65667 4.1126 9.34333 5.2501 12.75H4.66676",
    stroke: "#626262",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.25C9.8875 5.65667 9.8875 9.34333 8.75 12.75",
    stroke: "#626262",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 9.83333V9.25C5.15667 10.3875 8.84333 10.3875 12.25 9.25V9.83333",
    stroke: "#626262",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 5.74998C5.15667 4.61248 8.84333 4.61248 12.25 5.74998",
    stroke: "#626262",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicIcon);
export default __webpack_public_path__ + "static/media/public-icon.68c8e0dc4b2d265b7710dd10a0d4f330.svg";
export { ForwardRef as ReactComponent };